export function getRatingValue(ratings) {
    if (!ratings) return null;
    if (typeof ratings.value === 'string') return ratings.value;
    if (Array.isArray(ratings) && ratings[0]?.value) return ratings[0].value;
    return null;
};
